"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiContentPackagesClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const ContentPackageConverter_1 = require("../ContentPackageConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
class ApiContentPackagesClient extends ApiSubClient_1.ApiSubClient {
    getAll(query, sort) {
        const contentPackagesLink = this.getLinkOrThrow('getContentPackages');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(contentPackagesLink.href, {
            query: query,
            sortBy: sort,
        }))
            .then((it) => ContentPackageConverter_1.ContentPackageConverter.convertPackages(it));
    }
    get(id) {
        const contentPackageLink = this.getLinkOrThrow('getContentPackage');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(contentPackageLink.href, { id }))
            .then((it) => ContentPackageConverter_1.ContentPackageConverter.convertPackage(it.data));
    }
    replace(id, newContentPackage) {
        const updateContentPackageLink = this.getLinkOrThrow('updateContentPackage');
        return this.axios
            .put((0, expandUrlTemplate_1.default)(updateContentPackageLink.href, { id }), newContentPackage)
            .then((it) => ContentPackageConverter_1.ContentPackageConverter.convertPackage(it.data));
    }
    create(newContentPackage) {
        const createContentPackageLink = this.getLinkOrThrow('createContentPackage');
        return this.axios
            .post(createContentPackageLink.href, newContentPackage)
            .then((it) => ApiContentPackagesClient.extractIdFromLocation(it));
    }
    static extractIdFromLocation(response) {
        const link = response.headers.location;
        return link.substr(link.lastIndexOf('/') + 1);
    }
}
exports.ApiContentPackagesClient = ApiContentPackagesClient;
//# sourceMappingURL=ApiContentPackagesClient.js.map